export const heroFeature = {
  kicker: "深挖追踪 · 复盘档案",
  title:
    "从一封深夜声明到全网追问，「回锅顶流」三年三次改口全程复盘",
  summary:
    "我们把散落在各平台的帖子、声明与直播切片按时间对齐：哪些说法前后矛盾、哪些截图疑似拼接、哪一步让风向彻底倒转。先给结论，再放证据链。",
  cover:
    "https://readdy.ai/api/search-image?query=editorial%20journalism%20still%20life%20of%20stacked%20newspapers%20and%20papers%20under%20a%20single%20dramatic%20ring%20light%20on%20a%20dark%20wooden%20desk%2C%20warm%20amber%20and%20vermillion%20duotone%20lighting%2C%20symbolic%20investigation%20mood%2C%20no%20people%2C%20no%20text%2C%20cinematic%20high%20contrast%2C%20clean%20balanced%20editorial%20composition%20with%20soft%20shadows&width=1200&height=800&seq=cover-feature-01&orientation=landscape",
  source: "深挖组",
  readTime: "12 分钟深度",
  hot: "爆",
};

export const heroStack = [
  {
    id: "s1",
    cat: "实锤讨论",
    title: "「雨下主播」实锤帖被逐帧校对：截图时间线疑似对不上",
    heat: "9.8 万讨论",
    tag: "证据链",
    cover:
      "https://readdy.ai/api/search-image?query=close%20up%20of%20a%20smartphone%20screen%20showing%20blurred%20chat%20message%20conversation%20bubbles%20lying%20on%20a%20warm%20desk%20beside%20a%20magnifier%20and%20coffee%2C%20amber%20table%20lamp%20glow%2C%20vermillion%20accent%2C%20symbolic%20fact%20checking%20investigation%2C%20no%20people%2C%20no%20readable%20text%2C%20editorial%20cinematic%20mood&width=640&height=420&seq=cover-stack-01&orientation=landscape",
  },
  {
    id: "s2",
    cat: "时间线",
    title: "一条深夜回应搅动四天：事件时间线节点全对齐版",
    heat: "6.2 万浏览",
    tag: "节点整理",
    cover:
      "https://readdy.ai/api/search-image?query=top%20view%20of%20a%20wooden%20desk%20with%20a%20vintage%20tape%20recorder%2C%20spiral%20notebook%20and%20coffee%20cup%2C%20warm%20evening%20window%20light%2C%20symbolic%20timeline%20documentation%20and%20recording%20mood%2C%20no%20people%2C%20no%20text%2C%20soft%20amber%20tones%2C%20editorial%20photography&width=640&height=420&seq=cover-stack-02&orientation=landscape",
  },
  {
    id: "s3",
    cat: "后续进展",
    title: "品牌方同日公告解约，后续进展仍在持续发酵",
    heat: "5.1 万讨论",
    tag: "新进展",
    cover:
      "https://readdy.ai/api/search-image?query=a%20single%20bright%20spotlight%20hitting%20an%20empty%20stage%20with%20drawn%20curtain%20and%20microphone%20stand%20silhouette%2C%20warm%20vermillion%20and%20amber%20dramatic%20lighting%2C%20symbolic%20of%20public%20statement%20and%20contract%20change%2C%20no%20people%2C%20no%20text%2C%20cinematic%20editorial%20minimalist%20composition&width=640&height=420&seq=cover-stack-03&orientation=landscape",
  },
  {
    id: "s4",
    cat: "深挖",
    title: "三年改口背后：一份考据把时间线又往前推了两个月",
    heat: "4.4 万浏览",
    tag: "独家考据",
    cover:
      "https://readdy.ai/api/search-image?query=old%20paper%20archives%20and%20yellowed%20documents%20spread%20on%20a%20desk%20with%20a%20pen%20and%20reading%20lamp%2C%20warm%20aged%20paper%20tones%20with%20subtle%20vermillion%20highlights%2C%20symbolic%20of%20deep%20archival%20research%20and%20fact%20checking%2C%20no%20people%2C%20no%20text%2C%20editorial%20documentary%20mood&width=640&height=420&seq=cover-stack-04&orientation=landscape",
  },
  {
    id: "s5",
    cat: "反转复盘",
    title: "风向两连变，评论区这场反转究竟是怎么发生的",
    heat: "3.9 万讨论",
    tag: "舆论复盘",
    cover:
      "https://readdy.ai/api/search-image?query=abstract%20smooth%20waves%20of%20warm%20orange%20and%20deep%20charcoal%20fabric%20flowing%20diagonally%2C%20symbolic%20of%20shifting%20public%20opinion%20and%20reversal%2C%20soft%20studio%20light%2C%20no%20people%2C%20no%20text%2C%20elegant%20minimal%20abstract%20editorial%20background&width=640&height=420&seq=cover-stack-05&orientation=landscape",
  },
];

export const tickerItems = [
  "直播切片比对曝光 · 凌晨账号改名 引新一波追问",
  "「山哥」合同争议 时间线更新至第 11 天",
  "饭圈支出清单复盘上线 · 实锤讨论开帖",
  "某综艺剪辑争议 反转复盘已出第二篇",
  "品牌声明合集更新 · 后续进展栏目跟进中",
  "年度复盘档案扩容 · 新增三个专题合集",
];

export const hotRank = [
  { id: 1, title: "「回锅顶流」三年三说法 · 证据链汇总帖", tag: "实锤讨论", heat: "92.6万", trend: "up" },
  { id: 2, title: "停播第 9 天：女主播去哪了 时间线复盘", tag: "时间线", heat: "78.1万", trend: "up" },
  { id: 3, title: "聊天记录疑似拼接 原帖已被逐帧校对", tag: "实锤讨论", heat: "66.4万", trend: "up" },
  { id: 4, title: "解约声明同日官宣 后续进展一图看懂", tag: "后续进展", heat: "55.2万", trend: "up" },
  { id: 5, title: "风向两连变 这场反转复盘被转疯了", tag: "反转复盘", heat: "48.7万", trend: "down" },
  { id: 6, title: "旧采访被扒出 时间线又往前推了两个月", tag: "深挖", heat: "41.9万", trend: "up" },
  { id: 7, title: "直播切片逐句比对帖 评论区吵翻了", tag: "实锤讨论", heat: "37.5万", trend: "down" },
  { id: 8, title: "工作室二次声明 措辞被逐条解读复盘", tag: "反转复盘", heat: "31.2万", trend: "up" },
  { id: 9, title: "品牌方回应汇总 后续进展持续跟进中", tag: "后续进展", heat: "26.8万", trend: "down" },
  { id: 10, title: "澄清档案上线 假料已被多条时间线打脸", tag: "深挖", heat: "22.3万", trend: "up" },
];

export const topicTiles = [
  {
    title: "2026 年度复盘档案",
    desc: "把今年所有爆雷与反转按月份对齐，反转到什么程度一目了然。",
    count: "126 篇复盘",
    tag: "全年索引",
    cover:
      "https://readdy.ai/api/search-image?query=flat%20lay%20of%20an%20open%20calendar%20and%20coffee%20on%20a%20desk%20with%20warm%20morning%20light%2C%20amber%20and%20vermillion%20tones%2C%20symbolic%20of%20a%20yearly%20timeline%20archive%2C%20no%20people%2C%20no%20readable%20text%2C%20editorial%20minimal%20composition&width=720&height=640&seq=topic-01&orientation=squarish",
  },
  {
    title: "塌房事件档案",
    desc: "从爆出到声明到解约，把每一起的实锤讨论与后续进展收进同一册。",
    count: "43 起案例",
    tag: "合集",
    cover:
      "https://readdy.ai/api/search-image?query=black%20paper%20file%20folder%20and%20documents%20stacked%20on%20a%20dark%20table%20under%20a%20single%20warm%20light%2C%20vermillion%20and%20charcoal%20tone%2C%20symbolic%20of%20confidential%20dossier%20collection%2C%20no%20people%2C%20no%20text%2C%20dramatic%20editorial%20still%20life&width=720&height=640&seq=topic-02&orientation=squarish",
  },
  {
    title: "直播翻车合集",
    desc: "直播间的临场反应最藏不住，切片逐句回看常有新发现。",
    count: "58 次复盘",
    tag: "切片复盘",
    cover:
      "https://readdy.ai/api/search-image?query=professional%20broadcast%20microphone%20and%20mixing%20panel%20in%20front%20of%20a%20soft%20bokeh%20studio%20light%2C%20warm%20amber%20lighting%2C%20symbolic%20of%20live%20streaming%20analysis%2C%20no%20people%2C%20no%20text%2C%20cinematic%20editorial%20composition&width=720&height=640&seq=topic-03&orientation=squarish",
  },
  {
    title: "声明措辞解读册",
    desc: "声明的每处改动都是信息，律师与公关视角逐句拆解。",
    count: "31 份解读",
    tag: "文本拆解",
    cover:
      "https://readdy.ai/api/search-image?query=close%20up%20of%20fountain%20pen%20writing%20on%20cream%20paper%20under%20warm%20desk%20lamp%2C%20soft%20amber%20and%20paper%20tones%2C%20symbolic%20of%20statement%20and%20official%20document%20analysis%2C%20no%20people%2C%20no%20readable%20text%2C%20editorial%20mood&width=720&height=640&seq=topic-04&orientation=squarish",
  },
  {
    title: "假料澄清档案",
    desc: "被反复转发的假截图与假时间线，在这里逐条打上核对标记。",
    count: "27 条澄清",
    tag: "防误导",
    cover:
      "https://readdy.ai/api/search-image?query=a%20magnifying%20glass%20over%20spread%20out%20newspaper%20pages%20on%20a%20table%2C%20warm%20desk%20lighting%20with%20subtle%20orange%20accent%2C%20symbolic%20of%20rumor%20verification%20and%20clarification%2C%20no%20people%2C%20no%20text%2C%20investigative%20editorial%20composition&width=720&height=640&seq=topic-05&orientation=squarish",
  },
  {
    title: "吃瓜时间年表",
    desc: "把过去一年的大小瓜排成一条长轴，点开即见关键节点。",
    count: "300+ 节点",
    tag: "年表索引",
    cover:
      "https://readdy.ai/api/search-image?query=long%20horizontal%20warm%20paper%20scroll%20with%20amber%20map%20pins%20along%20its%20length%20on%20a%20wooden%20surface%2C%20soft%20warm%20light%2C%20symbolic%20of%20a%20timeline%20index%20and%20chronology%2C%20no%20people%2C%20no%20readable%20text%2C%20editorial%20minimal%20still%20life&width=720&height=640&seq=topic-06&orientation=squarish",
  },
];